export const URL_PARAMS: Record<string, string> = {
  // App params
  UUID: 'uuid',
  ORDER_PARENT_NUMBER: 'oid',
  USER_GUID: 'userGuid',
  PAGE: 'page',
  PAGE_SIZE: 'pageSize',
  SELLER: 'seller',
  PRODUCT_GROUP: 'productGroup',
  GROUP: 'group',
  STATUS: 'status',
  SIZE: 'size',
  ONLY_WINNERS: 'onlyWinners',
  SORTING_STRATEGY: 'sortingStrategy',
};
